import { ChangeDetectionStrategy, Component, computed, inject, linkedSignal, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalComponent } from "../../modules/modal/modal.component";
import { ModalHeaderComponent } from "../../modules/modal/modal.header.component";
import { S25RichTextEditorModule } from "../../modules/s25-rich-text-editor/s25.rich.text.editor.module";
import { S25LoadingInlineModule } from "../../modules/s25-loading/s25.loading.inline.module";
import { S25ModalModule } from "../../modules/s25-modal/s25.modal.module";
import { ViewerMessageService } from "../../services/viewer.message.service";
import { FlsStore } from "../../stores/fls.store";
import { s25Resource } from "../../util/s25.resource";

@Component({
    template: `
        <s25-modal-header [data]="params()" />
        <div class="modal-body">
            @if (viewerMessage.resource.isLoading()) {
                <s25-ng-loading-inline-static />
            } @else if (canEdit()) {
                <div class="ngMessageArea">
                    <s25-ng-rich-text-editor [(modelValue)]="workingMessage" />
                </div>
            }
        </div>
        <s25-ng-modal-footer [content]="footerTemplate" [bordered]="true" />
        <ng-template #footerTemplate>
            <div class="footerContainer">
                <button class="aw-button aw-button--outline" (click)="params()?.closeModal()">Close</button>
                @if (canEdit()) {
                    <button class="aw-button aw-button--primary" [disabled]="saving()" (click)="save()">Save</button>
                }
            </div>
        </ng-template>
    `,
    styles: `
        .footerContainer {
            display: flex;
            justify-content: flex-end;
        }
        .ngMessageArea {
            padding-bottom: 20px;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalHeaderComponent, S25RichTextEditorModule, S25LoadingInlineModule, S25ModalModule, FormsModule],
})
export class ViewerMessageModalComponent extends ModalComponent {
    static readonly size = "md";
    static readonly title = "Edit Viewer Message";

    readonly fls = inject(FlsStore);

    readonly viewerMessage = s25Resource(() => ViewerMessageService.getViewerMessage());
    readonly canEdit = computed(() => this.fls.hasFull("SYS_MOTD"));
    readonly workingMessage = linkedSignal(() => this.viewerMessage.value() ?? "");
    readonly saving = signal(false);

    async save() {
        if (this.saving()) return;
        this.saving.set(true);
        try {
            await ViewerMessageService.setViewerMessage(this.workingMessage());
            this.data.closeModal();
        } finally {
            this.saving.set(false);
        }
    }
}
